import { lazy, Suspense } from "react";

import FooterSection from "assets/Footer";
import Navbar from "../assets/Navbar";
import Banner from "../components/dashboardComponents/Banner";
import Catelouge from "../components/dashboardComponents/catelouge";
import ScreenScrollToTop from "../components/ScreenScrollToTop";

// 👇 Lazy loaded heavy sections
const FlashSale = lazy(
  () => import("components/dashboardComponents/flashSale"),
);
const FreeDeliveryProducts = lazy(
  () => import("components/dashboardComponents/freeDeliveryProducts"),
);
const TrendingProducts = lazy(
  () => import("components/dashboardComponents/trendingProducts"),
);
const NewProducts = lazy(
  () => import("components/dashboardComponents/newProducts"),
);
const SubCatalougeGroupByCatalouge = lazy(
  () => import("components/dashboardComponents/SubCatalougeGroupByCatalouge"),
);
const TopCategories = lazy(
  () => import("components/dashboardComponents/topCategories"),
);
const WhyUs = lazy(() => import("components/dashboardComponents/whyUs"));
const YoutubePreview = lazy(
  () => import("components/dashboardComponents/youtubePreview"),
);

const Dashboard = () => {

  return (
    <div className="bg-gray-100 relative">
      <Navbar />
      <Banner />
      <Catelouge />
      <Suspense fallback={<div></div>}>
        {" "}
        <FlashSale />
        <FreeDeliveryProducts />
        <TrendingProducts />
        <NewProducts />
        <SubCatalougeGroupByCatalouge />
        <TopCategories />
        <WhyUs />
        <YoutubePreview />
      </Suspense>

      <FooterSection />
      <ScreenScrollToTop />
    </div>
  );
};

export default Dashboard;
